export default __webpack_public_path__ + "static/media/StrippedSour.143666de.mp4";